module.exports = __webpack_public_path__ + "img/no-avatar-2.9a1f991a.jpg";